import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Content = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px;\n  height: 100%;\n  box-sizing: border-box;\n"], ["\n  padding: 10px;\n  height: 100%;\n  box-sizing: border-box;\n"])));
var templateObject_1;
